import { clsx } from 'clsx';
import type { ComponentPropsWithoutRef } from 'react';

export interface StoneSkeletonProps extends ComponentPropsWithoutRef<'div'> {
  /**
   * `sheen` (default): a slow band of light crosses the grain — "loading".
   * `still`: the grain alone — "nothing here yet" (a product without a photo).
   */
  tone?: 'sheen' | 'still';
}

/**
 * Loading placeholder shaped like the stone it stands for: a fixed grain tile with a slow band of
 * light crossing it (DESIGN_SYSTEM §2.1). The grain is painted once; only the band moves, through
 * `transform` (styles/components/media.css). Decorative — pair it with a live region or a
 * `role="status"` label where the loading state matters to assistive technology.
 */
export function StoneSkeleton({
  tone = 'sheen',
  className,
  children,
  ...rest
}: StoneSkeletonProps) {
  return (
    <div
      className={clsx('stone-skeleton', className)}
      data-tone={tone}
      aria-hidden={children ? undefined : true}
      {...rest}
    >
      {children}
    </div>
  );
}
